import {
  getAuthCode,
  userNameLogin,
  verifyCode,
  adminMessageAllList
} from "@/api/api";
import router from  '@/router'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter,demomap } from '@/router'

const getDefaultState = () => {
  let data = sessionStorage.getItem('admininfo')? sessionStorage.getItem('admininfo'):{}
  return {
    token: getToken(),
    userinfo:sessionStorage.getItem('userinfo')? sessionStorage.getItem('userinfo'):{},
    name:sessionStorage.getItem('name')? sessionStorage.getItem('name'):'',
    avatar: '',
    roleId:sessionStorage.getItem('roleId')? sessionStorage.getItem('roleId'):'',
    role:{
      admin:47,
      vander:48,
    },
    roles: sessionStorage.getItem('roles')? sessionStorage.getItem('roles'):[],
  }
}
const state =  getDefaultState();

const mutations = {
  // 重置
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token;

  },
  SET_NAME: (state, name) => {
    sessionStorage.setItem('name',name);
    state.name = name
  },
  SET_USERINFO: (state, userinfo)=>{
    sessionStorage.setItem('userinfo',JSON.stringify(userinfo));
    state.userinfo = userinfo;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES:(state, roles)=>{
    let arr =  demomap.concat(roles);
    state.roles =JSON.stringify(arr);
    console.log('新路由表',arr);
    console.log('本身路由',router.options.routes);
    // const myroutet = router.options.routes;
    // router.addRoutes(arr);
    // router.options.routes=arr
    // this.$router不是响应式的，所以手动将路由元注入路由对象

    sessionStorage.setItem('roles',JSON.stringify(arr))
  }
}

const actions = {
  async loginByCode({ commit,state }, result){
    let { data:{code, data,message} } = result;
    sessionStorage.setItem('roleId',data.account.role)
    state.Id = data.account.id;
    commit('SET_TOKEN', data.account.token);
    commit('SET_NAME', data.account.username);
    commit('SET_USERINFO', data.account);
    commit('SET_ROLES', data.permissions);
    setToken(data.account.token);
  },
  // 用户登录
  async login({ commit,state }, userInfo) {
    let result = await userNameLogin(userInfo);
    let { data:{code, data,message} } = result;
    console.log('数据',result.data)
    if (code == 0) {
      console.log('userjs:', data);
      sessionStorage.setItem('roleId',data.account.role)
       state.Id = data.account.id;
      commit('SET_TOKEN', data.account.token);
      commit('SET_NAME', data.account.username);
      commit('SET_USERINFO', data.account);
      commit('SET_ROLES', data.permissions);
      setToken(data.account.token);
      return {
        code:0,message
      };
    } else {
      console.log('登录失败')
      return {
        code:-1,
        message:message
      }
    }
  },
  getuser_admin({state}){
    return state.rule
  },
  getuser_rule({state}){
    return state.userInfo
  },
  // 用户退出
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
        removeToken() // must remove  token  first
        resetRouter()
        commit('RESET_STATE');
        resolve(true);
        router.replace('/login')
        sessionStorage.clear()
    })
  },

  // 获取权限路由表
  GET_ROLES({ commit,state }){
    // return new Promise((resolve,reject)=>{
      if(state.roles)
      return state.roles;
    // })
  },

  // 清除 token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  },

  /**
   *
   * @param {userInfo} 包含用户  权限表  信息表
   *
   */
    GetInfo({ commit ,state}, userInfo){
      //  模拟用户权限
      console.log('请求用户')
      let  perms = [
        'admin','vander'
      ]
      return perms
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

